export const API_KEY_ENV_NAME = 'LECHUN_API_KEY'

const encodeUtf8Base64 = (value) => {
    const binary = encodeURIComponent(value).replace(
        /%([0-9A-F]{2})/g,
        (_, hex) => String.fromCharCode(parseInt(hex, 16))
    )
    return window.btoa(binary)
}

const encodeUtf16LeBase64 = (value) => {
    let binary = ''
    for (let i = 0; i < value.length; i += 1) {
        const codeUnit = value.charCodeAt(i)
        binary += String.fromCharCode(codeUnit & 0xff, codeUnit >>> 8)
    }
    return window.btoa(binary)
}

const requireApiKey = (apiKey) => {
    if (typeof apiKey !== 'string' || !apiKey) {
        throw new Error('缺少完整 API Key')
    }
    return apiKey
}

const buildWindowsPowerShellScript = (apiKey) => {
    const keyBase64 = encodeUtf8Base64(requireApiKey(apiKey))

    return `$ErrorActionPreference = 'Stop'
try {
    $value = [Text.Encoding]::UTF8.GetString([Convert]::FromBase64String('${keyBase64}'))
    [Environment]::SetEnvironmentVariable('${API_KEY_ENV_NAME}', $value, [EnvironmentVariableTarget]::User)
    $saved = [Environment]::GetEnvironmentVariable('${API_KEY_ENV_NAME}', [EnvironmentVariableTarget]::User)
    if ($saved -cne $value) {
        throw 'Environment variable verification failed.'
    }
    Write-Host ''
    Write-Host '[OK] ${API_KEY_ENV_NAME} 已为当前 Windows 用户配置完成。' -ForegroundColor Green
    Write-Host '请完全退出 Codex 后重新打开。'
} catch {
    Write-Host ''
    Write-Error '配置失败，请联系技术人员。'
    exit 1
} finally {
    Remove-Variable value, saved -ErrorAction SilentlyContinue
}
`
}

export const buildMacInstallerScript = (apiKey) => {
    const keyBase64 = encodeUtf8Base64(requireApiKey(apiKey))

    return `#!/bin/bash
set -euo pipefail

KEY_B64='${keyBase64}'
KEYCHAIN_SERVICE='lechun-vibe-api-key'
ENV_NAME='${API_KEY_ENV_NAME}'
INSTALL_DIR="$HOME/.lechun"
SHELL_LOADER="$INSTALL_DIR/load-api-key.sh"
LAUNCH_LOADER="$INSTALL_DIR/load-api-key-launchctl.sh"
LAUNCH_LABEL='cc.lechun.api-key-env'
LAUNCH_AGENT="$HOME/Library/LaunchAgents/$LAUNCH_LABEL.plist"
GUI_DOMAIN="gui/$(/usr/bin/id -u)"

finish() {
    status=$?
    trap - EXIT
    echo
    if [ "$status" -eq 0 ]; then
        echo "[OK] $ENV_NAME 已为当前 Mac 用户配置完成。"
        echo "请完全退出 Codex 后重新打开。"
    else
        echo "[ERROR] 配置失败，请联系技术人员。"
    fi
    echo
    if [ -r /dev/tty ]; then
        printf "按回车键结束..."
        read -r _ </dev/tty || true
    fi
    exit "$status"
}
trap finish EXIT

API_KEY="$(printf '%s' "$KEY_B64" | /usr/bin/base64 -D)"
ACCOUNT="$(/usr/bin/id -un)"

/usr/bin/security add-generic-password \
    -U \
    -a "$ACCOUNT" \
    -s "$KEYCHAIN_SERVICE" \
    -w "$API_KEY" >/dev/null

/bin/mkdir -p "$INSTALL_DIR" "$HOME/Library/LaunchAgents"
/bin/chmod 700 "$INSTALL_DIR"

/bin/cat > "$SHELL_LOADER" <<'SHELL_LOADER_EOF'
#!/bin/sh
LECHUN_API_KEY_VALUE=$(/usr/bin/security find-generic-password -a "$(/usr/bin/id -un)" -s 'lechun-vibe-api-key' -w 2>/dev/null || true)
if [ -n "$LECHUN_API_KEY_VALUE" ]; then
    export LECHUN_API_KEY="$LECHUN_API_KEY_VALUE"
fi
unset LECHUN_API_KEY_VALUE
SHELL_LOADER_EOF
/bin/chmod 700 "$SHELL_LOADER"

/bin/cat > "$LAUNCH_LOADER" <<'LAUNCH_LOADER_EOF'
#!/bin/sh
LECHUN_API_KEY_VALUE=$(/usr/bin/security find-generic-password -a "$(/usr/bin/id -un)" -s 'lechun-vibe-api-key' -w 2>/dev/null || true)
if [ -n "$LECHUN_API_KEY_VALUE" ]; then
    /bin/launchctl setenv LECHUN_API_KEY "$LECHUN_API_KEY_VALUE"
fi
unset LECHUN_API_KEY_VALUE
LAUNCH_LOADER_EOF
/bin/chmod 700 "$LAUNCH_LOADER"

SOURCE_LINE='[ -f "$HOME/.lechun/load-api-key.sh" ] && . "$HOME/.lechun/load-api-key.sh"'
ensure_profile_source() {
    profile="$1"
    /usr/bin/touch "$profile"
    if ! /usr/bin/grep -Fq "$SOURCE_LINE" "$profile"; then
        printf '\\n# Lechun API Key\\n%s\\n' "$SOURCE_LINE" >> "$profile"
    fi
}

ensure_profile_source "$HOME/.zshenv"
ensure_profile_source "$HOME/.bash_profile"
ensure_profile_source "$HOME/.bashrc"

/bin/cat > "$LAUNCH_AGENT" <<'PLIST_EOF'
<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd">
<plist version="1.0">
<dict>
    <key>Label</key>
    <string>cc.lechun.api-key-env</string>
    <key>ProgramArguments</key>
    <array>
        <string>/bin/sh</string>
        <string>-c</string>
        <string>exec "$HOME/.lechun/load-api-key-launchctl.sh"</string>
    </array>
    <key>RunAtLoad</key>
    <true/>
</dict>
</plist>
PLIST_EOF
/bin/chmod 600 "$LAUNCH_AGENT"

/bin/launchctl setenv "$ENV_NAME" "$API_KEY"
/bin/launchctl bootout "$GUI_DOMAIN/$LAUNCH_LABEL" >/dev/null 2>&1 || true
if ! /bin/launchctl bootstrap "$GUI_DOMAIN" "$LAUNCH_AGENT" >/dev/null 2>&1; then
    /bin/launchctl load "$LAUNCH_AGENT"
fi
/bin/launchctl kickstart -k "$GUI_DOMAIN/$LAUNCH_LABEL" >/dev/null 2>&1 || true

SAVED_KEY=$(/usr/bin/security find-generic-password -a "$ACCOUNT" -s "$KEYCHAIN_SERVICE" -w)
LAUNCH_KEY=$(/bin/launchctl getenv "$ENV_NAME" || true)
if [ "$SAVED_KEY" != "$API_KEY" ] || [ "$LAUNCH_KEY" != "$API_KEY" ]; then
    echo "Environment variable verification failed." >&2
    exit 1
fi

unset KEY_B64 API_KEY SAVED_KEY LAUNCH_KEY
`
}

export const buildMacTerminalCommand = (apiKey) => {
    const scriptBase64 = encodeUtf8Base64(buildMacInstallerScript(apiKey))
    return `printf '%s' '${scriptBase64}' | /usr/bin/base64 -D | /bin/bash`
}

export const buildWindowsCmdCommand = (apiKey) => {
    const scriptBase64 = encodeUtf16LeBase64(buildWindowsPowerShellScript(apiKey))
    return `powershell.exe -NoLogo -NoProfile -ExecutionPolicy Bypass -EncodedCommand ${scriptBase64}`
}
